import { getWindowRoleSync } from "./use-window-role";
import { prepareQueuedSpeech, speechLookahead } from "./tts-lookahead-runtime";
import type { SpeechTicket } from "./tts-lookahead";

const preparations = new Map<
  string,
  { ticket: SpeechTicket; released: AbortController }
>();
export function preparePresentationSpeech(
  source: string,
  text: string,
  signal: AbortSignal,
): void {
  if (
    getWindowRoleSync() !== "owner" ||
    preparations.has(source) ||
    signal.aborted
  )
    return;
  const released = new AbortController();
  const ticket = prepareQueuedSpeech(
    text.replace(/\s+/g, " ").trim(),
    () => !signal.aborted && !released.signal.aborted,
    true,
  );
  if (!ticket) return;
  preparations.set(source, { ticket, released });
  signal.addEventListener(
    "abort",
    () => {
      if (preparations.get(source)?.ticket === ticket)
        preparations.delete(source);
      speechLookahead.prune();
    },
    { once: true },
  );
}
export function takePresentationPreparation(
  source: string,
): SpeechTicket | undefined {
  const prepared = preparations.get(source);
  preparations.delete(source);
  return prepared?.ticket;
}
/** Speech that will never play: free its prepared audio now, not at run end. */
export function releasePresentationPreparation(source: string): void {
  preparations.get(source)?.released.abort();
  takePresentationPreparation(source);
  speechLookahead.prune();
}
